const menWomenFixedCatId = () => {
  return {
    women: 22,
    men: 23,
    kidsGirls: 21
  };
};

export default menWomenFixedCatId;
